"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { usePathname } from "next/navigation";

const LazyWhatsappWatiWidget = dynamic(
  () => import("@/components/chatbot/WhatsappWatiWidget"),
  { ssr: false, loading: () => null },
);

export default function DeferredWhatsappWidget({
  minDelay = 1000,
}: {
  minDelay?: number;
}) {
  const pathname = usePathname();
  const [shouldLoad, setShouldLoad] = useState(false);
  const isThankYouPage = pathname?.startsWith("/thank-you");

  useEffect(() => {
    if (isThankYouPage) return;

    let cancelled = false;
    const start = performance.now();

    function trigger() {
      const elapsed = performance.now() - start;
      const remaining = Math.max(0, minDelay - elapsed);
      setTimeout(() => {
        if (!cancelled) setShouldLoad(true);
      }, remaining);
    }

    function onWindowLoad() {
      if ("requestIdleCallback" in window) {
        (window as any).requestIdleCallback(trigger, { timeout: 2000 });
      } else {
        setTimeout(trigger, 1200);
      }
    }

    if (document.readyState === "complete") {
      onWindowLoad();
    } else {
      window.addEventListener("load", onWindowLoad, { once: true });
    }

    return () => {
      cancelled = true;
    };
  }, [minDelay]);

  if (isThankYouPage || !shouldLoad) return null;
  return <LazyWhatsappWatiWidget />;
}
